// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2v5TE","col":"CardReaderDesc_col__n6K2O","label":"CardReaderDesc_label__31YgK"};